<template>
  <div
    class="form-group"
    :class="{
      'is-invalid': hasErrorsBoth,
      'has-moderation': hasModeration
    }"
  >
    <slot
      :errors="activeErrors"
      :events="events"
      :first-error-message="activeErrorMessagesBoth"
      :has-errors="hasErrorsBoth"
      :validator="preferredValidator"
    />

    <component
      :is="commentComponent"
      v-if="canModerate"
      id="id"
      :name="name"
      @set:moderation="setModeration"
      @has:comments="hasComments = $event"
    />
  </div>
</template>

<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";
import serverSideValidation from "@/mixins/ServerSideValidation";

import AdminCertificationComment from "./BaseAdminCertificationComment";
import UserCertificationComment from "./BaseUserCertificationComment";

import { mapState, mapGetters } from "vuex";

export default {
  name: "CertificationFormGroup",
  components: {
    UserCertificationComment,
    AdminCertificationComment
  },
  mixins: [singleErrorExtractorMixin, serverSideValidation],
  props: {
    cols: {
      type: String,
      default: "col-md-offset-4 col-md-8 col-xs-12"
    },
    canModerate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      moderation: this.canModerate,
      hasComments: false
    };
  },
  computed: {
    ...mapState("User", ["user"]),
    ...mapGetters("User", ["isAdmin", "isUser"]),
    ...mapState("Form", ["formDisabled"]),
    ...mapState("Event", ["moderationDisabled"]),
    commentComponent() {
      return this.isAdmin
        ? "AdminCertificationComment"
        : "UserCertificationComment";
    },
    hasModeration() {
      return (
        ((this.moderation && this.hasComments) ||
          (this.canModerate && this.isAdmin)) &&
        !this.moderationDisabled
      );
    }
  },
  methods: {
    setModeration(value) {
      this.moderation = value;
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.form-group.has-moderation {
  .form__group {
    position: relative;
  }

  .form__group:after {
    content: " ";
    border-left: 2px solid $col-polmed-gray1;
    position: absolute;
    top: 40px;
    left: 18px;
    height: calc(100% - 30px);
  }
  .form__group--horizontal:after {
    left: 3px;
  }
  .form__group--horizontal.form__group--no-number:after {
    display: none;
  }
}
</style>
